import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScCurrencyUser = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.secondaryColor3}`};
  padding: 16px;
  margin: -16px -16px 0 -16px;
  button {
    width: 100%;
  }
  @media (${device.mobile}) {
    padding: 16px 16px 0 16px;
  }
  button {
    min-width: unset !important;
  }
  .selector + button {
    height: 36px;
    @media (${device.mobile}) {
      height: 48px;
    }
  }
  .title-currency {
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.16px;
    text-transform: capitalize;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.whiteColor};
    @media (${device.mobile}) {
      display: none;
    }
  }
  .row {
    display: flex;

    & > .selector,
    & > button {
      width: 50%;
    }

    & > .selector {
      margin-right: 4px;
    }
    & > button {
      margin-left: 4px;
    }
  }
`;
